<template>
  <div>
    <b-card
      :class="{
        'm-2 p-2': source === 'default',
        'm-0 shadow-none showScroll': source !== 'default',
      }"
      no-body
    >
      <b-row class="justify-content-between mb-2 align-items-center">
        <b-col cols="6" v-if="source === 'default'">
          <div class="d-flex align-items-center">
            <h5 v-if="panel.id" class="mb-0">
              {{ $t("intelbras.devices") }} {{ panel.name }}
            </h5>
            <div :style="styleStatusPanel"></div>
            <span>{{ textStatusPanel }}</span>
          </div>
        </b-col>
        <b-col
          :cols="source === 'default' ? 6 : 12"
          :class="{ 'mt-1 px-2': source !== 'default' }"
        >
          <b-form-input
            v-model="textFilter"
            :placeholder="$t('table.search')"
            class="mr-1"
            :class="{ 'form-control-sm': source !== 'default' }"
          />
        </b-col>
      </b-row>
      <b-table ref="bTable" :items="devicedFilter" :fields="fields">
        <template #cell(active)="data">
          <div
            :style="`background: ${data.item.active ? 'green' : 'red'};
                width: 1.5rem;
                height: 1.5rem;
                border-radius: 1rem;
                text-align: center;`"
          ></div>
        </template>
        <template #cell(status.open)="data">
          <div
            v-if="data.item.type === 'zones'"
            :style="`background: ${data.item.status.open ? 'green' : 'red'};
                width: 1.5rem;
                height: 1.5rem;
                border-radius: 1rem;
                text-align: center;`"
          ></div>
          <div v-else>N/A</div>
        </template>
        <template #cell(status.tamper)="data">
          <div
            v-if="data.item.type === 'zones'"
            :style="`background: ${data.item.status.tamper ? 'green' : 'red'};
                width: 1.5rem;
                height: 1.5rem;
                border-radius: 1rem;
                text-align: center;`"
          ></div>
          <div v-else>N/A</div>
        </template>
        <template #cell(status.violated)="data">
          <div
            v-if="data.item.type === 'zones'"
            :style="`background: ${data.item.status.violated ? 'green' : 'red'};
                width: 1.5rem;
                height: 1.5rem;
                border-radius: 1rem;
                text-align: center;`"
          ></div>
          <div v-else>N/A</div>
        </template>
        <template #cell(actions)="data">
          <b-form-checkbox
            v-if="data.item.type === 'pgms'"
            :id="`${data.item.id}`"
            :name="`device-${data.item.id}`"
            :disabled="loading || !panel.active"
            :checked="data.item.active"
            :ref="`switch-${data.item.id}`"
            switch
            @change="togglePgm(data.index, data.item)"
          >
            {{ titleActionPgm(data.item.active) }}
          </b-form-checkbox>
          <b-form-checkbox
            v-if="data.item.type === 'zones'"
            :id="`${data.item.id}`"
            :name="`device-${data.item.id}`"
            :disabled="loading || !panel.active"
            :checked="data.item.active"
            :ref="`switch-${data.item.id}`"
            switch
            @change="activateOrDeactivateZone(data.index, data.item)"
          >
            {{ titleActionBypassedZone(data.item.active) }}
          </b-form-checkbox>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BTable
} from "bootstrap-vue";
import {computed, ref, onMounted} from "@vue/composition-api";
import {useUtils as useI18nUtils} from "@core/libs/i18n";
import {useToast} from "vue-toastification/composition";
import ToastificationContent
  from "@core/components/toastification/ToastificationContent.vue";
import router from '@/router';
import store from "@/store";
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BTable
  },
  props: {
    panelId: Number | String,
    source: {
      type: String,
      default: "default",
    },
  },
  setup(props) {
    //HOOKS
    onMounted(async () => await fetchDevices());

    //COMPOSABLES
    const {t, tc} = useI18nUtils();

    const toast = useToast();

    //DATA
    const fields = ref([
      {
        label: tc('actions.name', 2),
        key: 'actions'
      },
      {
        label: t('intelbras.type'),
        key: 'type'
      },
      {
        label: t('intelbras.name'),
        key: 'name',
      },
      {
        label: t('intelbras.active'),
        key: 'active',
      },
      {
        label: 'Open',
        key: 'status.open',
        formatter: (value, key, item) => {
          if (item.type === 'pgms') {
            return 'N/A';
          }

          return item.status.open;
        }
      },
      {
        label: 'Tamper',
        key: 'status.tamper',
        formatter: (value, key, item) => {
          if (item.type === 'pgms') {
            return 'N/A';
          }

          return item.status.tamper;
        }
      },
      {
        label: 'Violated',
        key: 'status.violated',
        formatter: (value, key, item) => {
          if (item.type === 'pgms') {
            return 'N/A';
          }

          return item.status.violated;
        }
      }
    ]);

    const loading = ref(false);

    const panel = ref({});

    const bTable = ref(null);

    const textFilter = ref('');

    const trans = {
      "actions.cancel": t("actions.cancel"),
      "messages.activate.title": t("messages.activate.title"),
      "messages.activate.confirm": t("messages.activate.confirm"),
      "messages.desactivate.title": t("messages.desactivate.title"),
      "messages.desactivate.confirm": t("messages.desactivate.confirm"),
      "messages.loading.title": t("messages.loading.title"),
      "messages.desactivate.error": t("messages.desactivate.error"),
      "messages.activate.error": t("messages.activate.error"),
      "messages.activate.activated_correctly": t("messages.activate.activated_correctly"),
      "messages.desactivate.desactivated_correctly": t("messages.desactivate.desactivated_correctly"),
      "messages.desactivate.desactivated_correctly_confirm": t("messages.desactivate.desactivated_correctly_confirm"),
      "messages.activate.activated_correctly_confirm": t("messages.activate.activated_correctly_confirm"),
      "intelbras.panelOffline": t("intelbras.panelOffline"),
      "messages.activate.activating": t("messages.activate.activating"),
      "messages.desactivate.deactivating": t("messages.desactivate.deactivating"),
    }

    //COMPUTED
    const devicedFilter = computed(() => {
      if (!textFilter.value) {
        return panel.value.devices || [];
      }

      return panel.value.devices.filter(device => {
        let {name} = device;

        return name.toLowerCase().includes(textFilter.value)
      })
    });

    const styleStatusPanel = computed(() => {
      if (!panel.value) {
        return {};
      }

      let {device} = panel.value;
      let green = 'green';
      let red = 'red';
      let orange = 'orange';
      let color = '';
      let style = {
        background: color,
        width: '1rem',
        height: '1rem',
        borderRadius: '1rem',
        textAlign: 'center',
        margin: '0 5px'
      }

      if (device?.online && panel.value.active) {
        style.background = green;
      } else if (device?.online && !panel.value.active) {
        style.background = orange;
      } else if (!device?.online && panel.value.active) {
        style.background = red;
      } else if (!device?.online && !panel.value.active) {
        style.background = red;
      }

      return style;
    });

    const textStatusPanel = computed(() => {
      if (!panel.value) {
        return '';
      }

      let {device} = panel.value;

      if (device?.online && panel.value.active) {
        return t('intelbras.panelStatusArmed');
      } else if (device?.online && !panel.value.active) {
        return t('intelbras.panelStatusDisarmed');
      } else if (!device?.online && panel.value.active) {
        return t('intelbras.panelStatusOffline');
      } else if (!device?.online && !panel.value.active) {
        return t('intelbras.panelStatusOffline');
      }
    });

    //METHODS
    const activateOrDeactivateZone = async function (index, zone) {
      const result = await confirmActionAlert(zone, this);

      if (result.isConfirmed) {
        loading.value = true;

        const toastId = createToast(zone);

        const params = {
          panel_id: panel.value.device.id,
          zone: zone.name
        }

        const path = (zone.status.bypassed) ?
          "intelbras_panels/activateZone" :
          "intelbras_panels/deactivateZone";

        store.dispatch(path, params)
          .then(() => {
            bTable.value.items[index].active = !zone.active;
            successAlertAction(zone, this);
          })
          .catch(error => {
            const message = error.response.data.message;
            errorAlertAction(zone, this, message);
            document.getElementById(zone.id).checked = zone.active;
          })
          .finally(() => {
            loading.value = false;
            toast.clear(toastId);
          });
      } else {
        document.getElementById(zone.id).checked = zone.active;
      }
    }

    const togglePgm = async function (index, pgm) {
      const result = await confirmActionAlert(pgm, this);

      if (result.isConfirmed) {
        loading.value = true;

        const toastId = createToast(pgm);

        const params = {
          panel_id: panel.value.device.id,
          pgm: pgm.name
        }

        store.dispatch("intelbras_panels/togglePgm", params)
          .then(() => {
            bTable.value.items[index].active = !pgm.active;
            successAlertAction(pgm, this);
          })
          .catch(error => {
            document.getElementById(pgm.id).checked = pgm.active;
            const message = error.response.data.message;
            errorAlertAction(pgm, this, message);
          })
          .finally(() => {
            toast.clear(toastId);
            loading.value = false;
          });

      } else {
        document.getElementById(pgm.id).checked = pgm.active;
      }
    }

    const confirmActionAlert = async function (device, scope) {
      const titleSwal = getTitleSwal(device);
      const confirmButton = getTitleConfirmButton(device);

      return await scope.$swal({
        title: titleSwal,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: confirmButton,
        cancelButtonText: trans["actions.cancel"],
        customClass: {
          confirmButton: "btn btn-primary text-capitalize",
          cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
        },
        buttonsStyling: false
      })
    }

    const createToast = (device) => {
      let title = (device.active)
        ? `${trans["messages.desactivate.deactivating"]} ${device.name}`
        : `${trans["messages.activate.activating"]} ${device.name}`;

      return toast({
        component: ToastificationContent,
        props: {
          title: title,
          icon: "LoaderIcon",
          variant: "warning",
        },
      }, {
        timeout: false,
      });
    }

    const errorAlertAction = async function (device, scope, message = null,) {
      let messageError = '';

      if (message) {
        messageError = message;
      } else {
        messageError = (device.active)
          ? trans["messages.desactivate.error"]
          : trans["messages.activate.error"];
      }

      await scope.$swal({
        title: 'Error',
        text: messageError,
        icon: "error",
      });
    }

    async function fetchDevices() {
      try {
        const { id } = router.currentRoute.params;
        const panelId = id || props.panelId;
        const response = await store.dispatch("intelbras_panels/show", panelId);
        panel.value = response.data;
      } catch {
        panel.value = {};
      }
    }

    const getTitleConfirmButton = (device) => (device.active)
      ? trans['messages.desactivate.confirm']
      : trans['messages.activate.confirm'];

    const getTitleSwal = (device) => (device.active)
      ? `${trans['messages.desactivate.title']} ${device.name}?`
      : `${trans['messages.activate.title']} ${device.name}?`;

    const iconBypassedZone = (bypassed) => bypassed
      ? 'PlusCircleIcon'
      : 'MinusCircleIcon';

    const iconOpenZone = (open) => (open)
      ? 'Minimize2Icon'
      : 'Maximize2Icon';

    const iconPgm = (active) => (active)
      ? 'LeftIcon'
      : 'ToggleRightIcon';

    const panelOfflineAlert = async function (scope) {
      await scope.$swal({
        title: 'Error',
        text: trans['intelbras.panelOffline'],
        icon: "error",
      });
    }

    const successAlertAction = async function (device, scope) {
      const titleConfirm = !(device.active)
        ? trans["messages.desactivate.desactivated_correctly"]
        : trans["messages.activate.activated_correctly"];

      const textConfirm = !(device.active)
        ? `${trans["messages.desactivate.desactivated_correctly_confirm"]} ${device.name}`
        : `${trans["messages.activate.activated_correctly_confirm"]} ${device.name}`;

      await scope.$swal({
        title: titleConfirm,
        text: textConfirm,
        icon: "success",
      });
    }

    const titleActionPgm = (active) => (active)
      ? t('intelbras.deactivate')
      : t('intelbras.activate');

    const titleActionBypassedZone = (bypassed) => bypassed ? t('intelbras.bypass') : t('intelbras.enable');

    const titleActionOpenZone = (open) => (open)
      ? t('intelbras.close')
      : t('intelbras.open');

    return {
      fields,
      loading,
      panel,
      bTable,
      textFilter,

      devicedFilter,
      styleStatusPanel,
      textStatusPanel,

      activateOrDeactivateZone,
      iconBypassedZone,
      iconPgm,
      iconOpenZone,
      titleActionBypassedZone,
      titleActionPgm,
      titleActionOpenZone,
      togglePgm
    }
  }
}
</script>

